import { apiFetch } from "./apiClient";

export async function getCustomerDevices() {
  const res = await apiFetch("/api/v1/list-devices");
  if (!res.ok) {
    throw new Error("Failed to fetch devices");
  }
  return res.json();
}

// Commands are either 'start', 'stop', 'pause', 'resume', 'dock'
export async function sendDeviceControlCommand(
  deviceId,
  command,
  zoneId = null,
  cleaningConfig = null,
) {
  let res;

  if (zoneId) {
    const body = { command: command, deviceId: deviceId };
    if (cleaningConfig) {
      body.cleaningConfig = cleaningConfig;
    }
    res = await apiFetch(`/api/services/controls/clean-zone-group/${zoneId}`, {
      method: "POST",
      body: JSON.stringify(body),
    });
    if (!res.ok) {
      throw new Error("Failed to fetch device data");
    }
  } else {
    const body = { deviceId: deviceId };
    if (cleaningConfig) {
      body.cleaningConfig = cleaningConfig;
    }
    res = await apiFetch(`/api/services/controls/${command}`, {
      method: "POST",
      body: JSON.stringify(body),
    });
    if (!res.ok) {
      throw new Error("Failed to fetch device data");
    }
  }
  console.log("Response from control command API:", res);
  return res.json();
}

export async function sendMultiZoneControlCommand(
  deviceId,
  command,
  zoneIds,
  cleaningConfig = null,
) {
  const body = { command, deviceId, zoneIds };

  if (cleaningConfig) {
    body.cleaningConfig = cleaningConfig;
  }

  const res = await apiFetch(`/api/services/controls/clean-zone-groups`, {
    method: "POST",
    body: JSON.stringify(body),
  });

  if (!res.ok) {
    throw new Error("Failed to send multi-zone control command");
  }

  return res.json();
}

export async function submitCustomerFeedback({
  deviceId,
  rating,
  comment = "",
}) {
  const res = await apiFetch(`/api/services/controls/customer-feedback`, {
    method: "POST",
    body: JSON.stringify({
      deviceId,
      rating,
      comment,
    }),
  });

  if (!res.ok) {
    throw new Error("Failed to submit customer feedback");
  }

  return res.json();
}
